'use client'

import { useEffect } from 'react'

/**
 * Hook: Auto cleanup on tab close
 * Опционально: очищает данные при закрытии вкладки (для безопасности)
 */
export function useLogoutCleanup(enabled: boolean = false) {
  useEffect(() => {
    if (!enabled) return

    const handleBeforeUnload = () => {
      // Очищаем только чувствительные данные
      sessionStorage.clear()
      
      // localStorage оставляем (для настроек типа theme/language)
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [enabled])
}
